import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CommonOutletTemplate } from "UI/CommonOutletTemplate";
import { AddNewSpecialistDialog } from "./AddNewSpecialistDialog";
import { EditSpecialistDialog } from "./EditSpecialistDialog";
import { useCurrentUserData } from "hooks/useUserData";
import { useDataGrid } from "hooks/useDataGrid";
import * as CSC from "SC";
import { GlobalContext } from "store/globalContext";
import { DataGrid } from "UI/DataGrid";
import { TextFieldWithEllipsis } from "UI/TextFiledWithEllipsis";

const columns = [
  {
    label: "Name",
    field: "name",
    xs: 2.5,
    sm: 2.5,
    md: 2.5,
  },
  {
    label: "Job title",
    field: "jobTitle",
    xs: 1.7,
    sm: 1.7,
    md: 1.7,
  },
  {
    label: "Email",
    field: "email",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ email }) => (
      <TextFieldWithEllipsis>{email ?? ""}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Phone",
    field: "phone",
    xs: 2,
    sm: 2,
    md: 2,
  },
  {
    label: "Practice",
    field: "organizationName",
    xs: 2.8,
    sm: 2.8,
    md: 2.8,
    renderer: ({ organizationName }) => (
      <TextFieldWithEllipsis>{organizationName ?? ""}</TextFieldWithEllipsis>
    ),
  },
];

const mobileColumns = [
  {
    label: "Name",
    field: "name",
    xs: 4,
    sm: 4,
    md: 4,
  },
  {
    label: "Job title",
    field: "jobTitle",
    xs: 3,
    sm: 3,
    md: 3,
    renderer: ({ jobTitle }) => (
      <TextFieldWithEllipsis>{jobTitle ?? ""}</TextFieldWithEllipsis>
    ),
  },
  {
    label: "Practice",
    field: "organizationName",
    xs: 5,
    sm: 5,
    md: 5,
    renderer: ({ organizationName }) => (
      <TextFieldWithEllipsis>{organizationName ?? ""}</TextFieldWithEllipsis>
    ),
  },
];

const comment = <div className="flex flex-col gap-2">
  <div className="font-bold text-black">Who is a sender?</div>
  Person clicking the Referral Stream button (Subsender, office manager, admin staff, etc.)
  </div>;

export const Senders = () => {
  const navigate = useNavigate();
  const { isReadOnlyAccess } = useCurrentUserData();
  const [isAddNewDialogOpen, setIsAddNewDialogOpen] = useState(false);
  const [currentSpecialistId, setCurrentSpecialistId] = useState("");
  const { userData } = useContext(GlobalContext);
  const disableDownload =
    userData?.role !== "Super Admin" && userData?.role !== "Admin";

  const dataGrid = useDataGrid({
    url: "/originators",
    defaultSorter: {
      name: "name",
      order: "asc",
    },
    defaultLimit: 25,
    gridConfigIndex: `${userData.cognitoId}-Senders`,
  });

  const handleRowClick = ({ id }) =>
    isReadOnlyAccess
      ? navigate(`/originator/${id}`)
      : setCurrentSpecialistId(id);

  return (
    <CommonOutletTemplate
      title="Senders"
      comment={comment}
      isLoading={!dataGrid?.rows}
    >
      <DataGrid
        columns={columns}
        mobileColumns={mobileColumns}
        handleRowClick={handleRowClick}
        {...dataGrid}
        disableDownload={disableDownload}
        afterSearchContent={
          !isReadOnlyAccess && (
            <CSC.BlueButton
              variant="outlined"
              onClick={() => setIsAddNewDialogOpen(true)}
            >
              Add New Sender
            </CSC.BlueButton>
          )
        }
      />
      {!isReadOnlyAccess && (
        <>
          <AddNewSpecialistDialog
            title="Add New Sender"
            role="Originator"
            apiPath="/originators"
            open={isAddNewDialogOpen}
            handleClose={() => setIsAddNewDialogOpen(false)}
            refreshList={() => dataGrid.loadData()}
          />
          <EditSpecialistDialog
            title="Sender Details"
            role="Originator"
            specialistId={currentSpecialistId}
            handleClose={() => setCurrentSpecialistId("")}
            refreshList={() => dataGrid.loadData()}
          />
        </>
      )}
    </CommonOutletTemplate>
  );
};
